import { defineMessages } from 'react-intl-next';

const _default_1: {
    readonly previewNotAvailable: {
        readonly id: "ai-mate.file-preview-modal.preview-not-available";
        readonly defaultMessage: "Preview not available for this file type";
        readonly description: "Message shown when file preview cannot be displayed";
    };
} = defineMessages({
    previewNotAvailable: {
        id: 'ai-mate.file-preview-modal.preview-not-available',
        defaultMessage: 'Preview not available for this file type',
        description: 'Message shown when file preview cannot be displayed',
    },
} as const);
export default _default_1;
